// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__uqIbt","description":"PatientConsentPreview_description__3ZA8g"};